import CadastroUsuario from "../../componentes/CadastroUsuario";

/* Componente de página para o cadastro de usuário
    Este elemento é referenciado na configuração de rotas em src/routes.js 
    Este componente encapsula o componente CadastroUsuario que contém o formulário real de cadastro 
*/
const Cadastro = () => {
    return (
        <div>
            <div className="container-fluid mt-3">
                <CadastroUsuario />
            </div>
        </div>
    )
}

export default Cadastro
  